// extracted by mini-css-extract-plugin
module.exports = {"links":"Links_links__HWjp-","linkDiv":"Links_linkDiv__wm9-5"};